import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const StyledSideNav = styled.nav`
  height: auto;
  width: 0;
  position: fixed;
  z-index: 11;
  top: ${({ theme }) => theme.headerHeight};
  bottom: 0;
  left: 0;
  background: ${({ theme }) => theme.header};

  /* overflow-x: hidden; Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.2s;
  overflow: auto;
  /* overflow-y: auto; */
  // padding-bottom: 100px !important;
  @media screen and (max-width: 1100px) {
    top: ${({ theme }) => theme.headerHeight};
  }
  @media screen and (max-width: 426px) {
    top: ${({ theme }) => theme.headerHeight};
  }
  @media screen and (max-height: 450px) {
    padding-top: 15px;
  }
  span {
    transition: all 0.3s linear;
  }
  &[data-sideopen='false'] {
    width: 60px;
    padding: calc(${({ theme }) => theme.chromeRadius} + 16px) 0 0;
    @media screen and (max-width: 768px) {
      padding: 0;
    }
    @media screen and (max-width: 1199px) {
      width: 100%;
      z-index: 2;
      /* -100% */
      transform: translate3d(-100%, 0, 0);
      /* transform: translate3d(0,-100%, 0); */
    }
    span {
      opacity: 0.8;
      color: #b2b2b2;
      margin-top: 6px;
      font-size: 9px;
      line-height: 1.2;
      letter-spacing: 0.04em;
      text-align: center;
    }
  }
  &[data-sideopen='true'] {
    width: 305px;
    padding: calc(${({ theme }) => theme.chromeRadius} + 18px) 24px 0 17px;
    background: ${({ theme }) => theme.header};
    @media screen and (max-width: 1199px) {
      width: 100%;
      z-index: 11;
      transform: translate3d(0, 0, 0);
      &[data-left='true'] {
        transform: translate3d(-100%, 0, 0);
      }
    }
    @media only screen and (max-width: 1199px) {
      padding: 0;
      padding-bottom: 50px;
    }
  }
`;
export const StyledSummary = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  @media only screen and (max-width: 1199px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 16px 16px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }
  @media screen and (min-width: 1200px) {
    display: none;
  }
  &[data-left='true'] {
    opacity: 0;
    user-select: none;
    width: 0;
  }
`;
export const StyledNavList = styled.div`
  position: relative;
`;

export const StyledNavHighlight = styled.div`
  position: absolute;
  top: 0;
  left: 6px;
  right: 6px;
  border-radius: 10px;
  background: ${({ theme }) => theme.headerControl};
  pointer-events: none;
  z-index: 0;
  opacity: ${({ $ready }) => ($ready ? 1 : 0)};
  transition: transform 0.28s cubic-bezier(0.34, 1.15, 0.64, 1),
    height 0.28s cubic-bezier(0.34, 1.15, 0.64, 1), opacity 0.16s ease;
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
  @media screen and (max-width: 1199px) {
    left: 8px;
    right: 8px;
    border-radius: 12px;
    background: ${({ theme }) => theme.headerControl};
    box-shadow: none;
  }
`;

export const StyledNavLinks = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  text-decoration: none;
  font-family: 'Archivo Condensed', 'Archivo', sans-serif;
  font-stretch: condensed;
  font-style: normal;
  font-weight: 500;
  font-size: 12.642px;
  line-height: 100%;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  transition: color 0.2s ease, opacity 0.2s ease;
  margin: 0;
  padding: 14px 8px;
  user-select: none;

  @media only screen and (max-width: 1199px) {
    margin: 0;
    padding: 11px 16px;
    gap: 12px;
    flex-direction: row;
    justify-content: flex-start;
    font-size: 14px;
    letter-spacing: 0.06em;
    color: rgba(255, 255, 255, 0.72);
    opacity: 1;
    svg {
      width: 20px;
      height: 20px;
    }
  }
  &.blocked {
    pointer-events: none;
    opacity: 0.3;
  }
  &.selected {
    color: ${({ theme }) => theme.headerText};
    span {
      color: ${({ theme }) => theme.headerText};
      opacity: 1;
    }
    #cup_icon {
      path {
        fill: #fff;
      }
    }
  }
  svg {
    display: block;
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    overflow: visible;
    transition: all 0.3s linear;
    margin-right: 0;
    /*  path {
      stroke: #bbb;
    } */

    /*  g {
      stroke: black;
    } */
  }
  span {
    display: block;
    color: #fff;
    opacity: 0.5;
    line-height: 1.2;
    text-align: center;
    @media screen and (max-width: 1199px) {
      display: block;
      text-align: left;
      opacity: 1;
      color: inherit;
    }
  }

  @media screen and (min-width: 1199px) {
    /* padding: 15px 21px; */
    /* padding: 27% 20%; */
    /* padding: 25%; */
    justify-content: center;
    /*  &::before {
      position: absolute;
      bottom: -15px;
      left: 50%;
      transform: translate(-50%, 0);
      content: attr(data-content);
      font-family: 'Archivo', sans-serif;
      font-weight: 500;
      font-size: 10px;
      line-height: 101%;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color: #b2b2b2;
    } */
    svg {
      margin: 0;
    }
  }
`;

export const StyledTextNavLink = styled(StyledNavLinks)`
  padding: 5px;
  text-align: center;
`;

export const StyledAvatar = styled.img`
  max-width: 65px;
  border-radius: 50%;
  @media only screen and (max-width: 1199px) {
    width: 44px;
    height: 44px;
    max-width: 44px;
    max-height: 44px;
    object-fit: cover;
    flex-shrink: 0;
  }
`;

export const StyledMobileContainer = styled.div`
  display: none;
  @media only screen and (max-width: 1199px) {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 12px;
    margin: 0;
    min-width: 0;
  }
`;

export const StyledIdentityCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  gap: 2px;
`;

export const StyledIdentityName = styled.div`
  margin: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: 'Archivo', sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  color: ${({ theme }) => theme.headerText};
`;

export const StyledRankingContainer = styled(NavLink)`
  position: relative;
  z-index: 2;
  height: 60px;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: -0.001em;
  color: #000000;
  margin: 0 24px;
  text-decoration: none;
  @media only screen and (max-width: 1199px) {
    height: auto;
    margin: 0;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.3;
    letter-spacing: 0.01em;
    color: ${({ theme }) => theme.headerMuted};
  }
  span {
    font-size: 12px;
    color: #999999;
    font-weight: normal;
  }
`;
export const StyledMoneyContainer = styled(NavLink)`
  height: 60px;
  padding: 10px 18px;
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: -0.001em;
  position: relative;
  color: #000000;
  text-decoration: none;
  z-index: 2;
  @media only screen and (max-width: 1199px) {
    color: #fff;
    text-align: center;
  }
  span {
    font-size: 12px;
    color: #999999;
    font-weight: normal;
  }
`;
export const StyledSidebar = styled.div`
  @media only screen and (min-width: 1199px) {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 50px;
  }
  @media only screen and (max-width: 1199px) {
    padding: 8px 0 4px;
  }
`;

export const StyledLegalRail = styled.div`
  @media only screen and (max-width: 1199px) {
    display: none;
  }
`;

export const StyledAccountBlock = styled.div`
  display: none;
  @media only screen and (max-width: 1199px) {
    display: block;
    margin: 4px 8px 0;
    padding: 8px 0 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }
`;

export const StyledSelectContainer = styled.div`
  display: none;
  flex-direction: row;
  justify-content: space-between;
  @media only screen and (max-width: 1199px) {
    display: block;
    width: 100%;
    margin: 0;
  }
`;
